// Mock data for language learning platform

export const languages = [
  { id: 'spanish', name: 'Spanish', flag: '🇪🇸', nativeName: 'Español' },
  { id: 'french', name: 'French', flag: '🇫🇷', nativeName: 'Français' },
  { id: 'german', name: 'German', flag: '🇩🇪', nativeName: 'Deutsch' },
  { id: 'italian', name: 'Italian', flag: '🇮🇹', nativeName: 'Italiano' },
  { id: 'hindi', name: 'Hindi', flag: '🇮🇳', nativeName: 'हिन्दी' },
  { id: 'tamil', name: 'Tamil', flag: '🇮🇳', nativeName: 'தமிழ்' },
  { id: 'kannada', name: 'Kannada', flag: '🇮🇳', nativeName: 'ಕನ್ನಡ' },
  { id: 'telugu', name: 'Telugu', flag: '🇮🇳', nativeName: 'తెలుగు' },
  { id: 'malayalam', name: 'Malayalam', flag: '🇮🇳', nativeName: 'മലയാളം' }
];

export const commonNouns = {
  spanish: [
    { english: 'Food', native: 'Comida', transliteration: 'koh-MEE-dah', category: 'nouns' },
    { english: 'Water', native: 'Agua', transliteration: 'AH-gwah', category: 'nouns' },
    { english: 'Transport', native: 'Transporte', transliteration: 'trahns-POR-teh', category: 'nouns' },
    { english: 'Taxi', native: 'Taxi', transliteration: 'TAHK-see', category: 'nouns' },
    { english: 'Hotel', native: 'Hotel', transliteration: 'oh-TEL', category: 'nouns' },
    { english: 'Restaurant', native: 'Restaurante', transliteration: 'reh-stow-RAHN-teh', category: 'nouns' },
    { english: 'Bathroom', native: 'Baño', transliteration: 'BAH-nyoh', category: 'nouns' },
    { english: 'Money', native: 'Dinero', transliteration: 'dee-NEH-roh', category: 'nouns' },
    { english: 'Help', native: 'Ayuda', transliteration: 'ah-YOO-dah', category: 'nouns' },
    { english: 'Hospital', native: 'Hospital', transliteration: 'oh-spee-TAHL', category: 'nouns' },
    { english: 'Pharmacy', native: 'Farmacia', transliteration: 'far-MAH-see-ah', category: 'nouns' },
    { english: 'Airport', native: 'Aeropuerto', transliteration: 'ah-eh-roh-PWEHR-toh', category: 'nouns' },
    { english: 'Train Station', native: 'Estación de tren', transliteration: 'eh-stah-see-OHN deh trehn', category: 'nouns' },
    { english: 'Market', native: 'Mercado', transliteration: 'mehr-KAH-doh', category: 'nouns' },
    { english: 'Street', native: 'Calle', transliteration: 'KAH-yeh', category: 'nouns' }
  ],
  french: [
    { english: 'Food', native: 'Nourriture', transliteration: 'noo-ree-TOOR', category: 'nouns' },
    { english: 'Water', native: 'Eau', transliteration: 'oh', category: 'nouns' },
    { english: 'Transport', native: 'Transport', transliteration: 'trahn-SPOR', category: 'nouns' },
    { english: 'Taxi', native: 'Taxi', transliteration: 'tahk-SEE', category: 'nouns' },
    { english: 'Hotel', native: 'Hôtel', transliteration: 'oh-TEL', category: 'nouns' },
    { english: 'Restaurant', native: 'Restaurant', transliteration: 'reh-stoh-RAHN', category: 'nouns' },
    { english: 'Bathroom', native: 'Toilettes', transliteration: 'twah-LET', category: 'nouns' },
    { english: 'Money', native: 'Argent', transliteration: 'ar-ZHAHN', category: 'nouns' },
    { english: 'Help', native: 'Aide', transliteration: 'ed', category: 'nouns' },
    { english: 'Hospital', native: 'Hôpital', transliteration: 'oh-pee-TAHL', category: 'nouns' },
    { english: 'Pharmacy', native: 'Pharmacie', transliteration: 'far-mah-SEE', category: 'nouns' },
    { english: 'Airport', native: 'Aéroport', transliteration: 'ah-eh-roh-POR', category: 'nouns' },
    { english: 'Train Station', native: 'Gare', transliteration: 'gar', category: 'nouns' },
    { english: 'Market', native: 'Marché', transliteration: 'mar-SHAY', category: 'nouns' },
    { english: 'Street', native: 'Rue', transliteration: 'roo', category: 'nouns' }
  ],
  hindi: [
    { english: 'Food', native: 'खाना', transliteration: 'khaa-naa', category: 'nouns' },
    { english: 'Water', native: 'पानी', transliteration: 'paa-nee', category: 'nouns' },
    { english: 'Transport', native: 'यातायात', transliteration: 'yaa-taa-yaat', category: 'nouns' },
    { english: 'Taxi', native: 'टैक्सी', transliteration: 'taik-see', category: 'nouns' },
    { english: 'Hotel', native: 'होटल', transliteration: 'ho-tal', category: 'nouns' },
    { english: 'Restaurant', native: 'रेस्तरां', transliteration: 'res-ta-raan', category: 'nouns' },
    { english: 'Bathroom', native: 'बाथरूम', transliteration: 'baath-room', category: 'nouns' },
    { english: 'Money', native: 'पैसा', transliteration: 'pai-saa', category: 'nouns' },
    { english: 'Help', native: 'मदद', transliteration: 'ma-dad', category: 'nouns' },
    { english: 'Hospital', native: 'अस्पताल', transliteration: 'as-pa-taal', category: 'nouns' },
    { english: 'Pharmacy', native: 'दवाखाना', transliteration: 'da-vaa-khaa-naa', category: 'nouns' },
    { english: 'Airport', native: 'हवाई अड्डा', transliteration: 'ha-vaai ad-daa', category: 'nouns' },
    { english: 'Train Station', native: 'रेलवे स्टेशन', transliteration: 'rail-way sta-shan', category: 'nouns' },
    { english: 'Market', native: 'बाजार', transliteration: 'baa-zaar', category: 'nouns' },
    { english: 'Street', native: 'सड़क', transliteration: 'sa-rak', category: 'nouns' }
  ]
};

export const commonVerbs = {
  spanish: [
    { english: 'Go', native: 'Ir', transliteration: 'eer', category: 'verbs' },
    { english: 'Eat', native: 'Comer', transliteration: 'koh-MEHR', category: 'verbs' },
    { english: 'Drink', native: 'Beber', transliteration: 'beh-BEHR', category: 'verbs' },
    { english: 'Want', native: 'Querer', transliteration: 'keh-REHR', category: 'verbs' },
    { english: 'Need', native: 'Necesitar', transliteration: 'neh-seh-see-TAHR', category: 'verbs' },
    { english: 'Buy', native: 'Comprar', transliteration: 'kohm-PRAHR', category: 'verbs' },
    { english: 'Pay', native: 'Pagar', transliteration: 'pah-GAHR', category: 'verbs' },
    { english: 'Help', native: 'Ayudar', transliteration: 'ah-yoo-DAHR', category: 'verbs' },
    { english: 'Find', native: 'Encontrar', transliteration: 'ehn-kohn-TRAHR', category: 'verbs' },
    { english: 'Stay', native: 'Quedarse', transliteration: 'keh-DAHR-seh', category: 'verbs' },
    { english: 'Come', native: 'Venir', transliteration: 'veh-NEER', category: 'verbs' },
    { english: 'Leave', native: 'Salir', transliteration: 'sah-LEER', category: 'verbs' },
    { english: 'Speak', native: 'Hablar', transliteration: 'ah-BLAHR', category: 'verbs' },
    { english: 'Understand', native: 'Entender', transliteration: 'ehn-tehn-DEHR', category: 'verbs' },
    { english: 'Wait', native: 'Esperar', transliteration: 'eh-speh-RAHR', category: 'verbs' }
  ],
  french: [
    { english: 'Go', native: 'Aller', transliteration: 'ah-LAY', category: 'verbs' },
    { english: 'Eat', native: 'Manger', transliteration: 'mahn-ZHAY', category: 'verbs' },
    { english: 'Drink', native: 'Boire', transliteration: 'bwahr', category: 'verbs' },
    { english: 'Want', native: 'Vouloir', transliteration: 'voo-LWAHR', category: 'verbs' },
    { english: 'Need', native: 'Avoir besoin', transliteration: 'ah-VWAHR beh-ZWAN', category: 'verbs' },
    { english: 'Buy', native: 'Acheter', transliteration: 'ash-TAY', category: 'verbs' },
    { english: 'Pay', native: 'Payer', transliteration: 'pay-YAY', category: 'verbs' },
    { english: 'Help', native: 'Aider', transliteration: 'ay-DAY', category: 'verbs' },
    { english: 'Find', native: 'Trouver', transliteration: 'troo-VAY', category: 'verbs' },
    { english: 'Stay', native: 'Rester', transliteration: 'reh-STAY', category: 'verbs' },
    { english: 'Come', native: 'Venir', transliteration: 'veh-NEER', category: 'verbs' },
    { english: 'Leave', native: 'Partir', transliteration: 'par-TEER', category: 'verbs' },
    { english: 'Speak', native: 'Parler', transliteration: 'par-LAY', category: 'verbs' },
    { english: 'Understand', native: 'Comprendre', transliteration: 'kohm-PRAHN-druh', category: 'verbs' },
    { english: 'Wait', native: 'Attendre', transliteration: 'ah-TAHN-druh', category: 'verbs' }
  ],
  hindi: [
    { english: 'Go', native: 'जाना', transliteration: 'jaa-naa', category: 'verbs' },
    { english: 'Eat', native: 'खाना', transliteration: 'khaa-naa', category: 'verbs' },
    { english: 'Drink', native: 'पीना', transliteration: 'pee-naa', category: 'verbs' },
    { english: 'Want', native: 'चाहना', transliteration: 'chaah-naa', category: 'verbs' },
    { english: 'Need', native: 'ज़रूरत होना', transliteration: 'za-roo-rat ho-naa', category: 'verbs' },
    { english: 'Buy', native: 'खरीदना', transliteration: 'kha-reed-naa', category: 'verbs' },
    { english: 'Pay', native: 'भुगतान करना', transliteration: 'bhug-taan kar-naa', category: 'verbs' },
    { english: 'Help', native: 'मदद करना', transliteration: 'ma-dad kar-naa', category: 'verbs' },
    { english: 'Find', native: 'ढूंढना', transliteration: 'dhoon-dhnaa', category: 'verbs' },
    { english: 'Stay', native: 'रहना', transliteration: 'rah-naa', category: 'verbs' },
    { english: 'Come', native: 'आना', transliteration: 'aa-naa', category: 'verbs' },
    { english: 'Leave', native: 'निकलना', transliteration: 'ni-kal-naa', category: 'verbs' },
    { english: 'Speak', native: 'बोलना', transliteration: 'bol-naa', category: 'verbs' },
    { english: 'Understand', native: 'समझना', transliteration: 'samajh-naa', category: 'verbs' },
    { english: 'Wait', native: 'इंतज़ार करना', transliteration: 'in-ta-zaar kar-naa', category: 'verbs' }
  ]
};

export const commonQuestions = {
  spanish: [
    { english: 'Where is the bathroom?', native: '¿Dónde está el baño?', transliteration: 'DOHN-deh eh-STAH ehl BAH-nyoh?', responses: ['A la derecha', 'A la izquierda', 'Al fondo'] },
    { english: 'How much does this cost?', native: '¿Cuánto cuesta esto?', transliteration: 'KWAHN-toh KWEH-stah EH-stoh?', responses: ['Diez euros', 'Veinte dólares', 'Es gratis'] },
    { english: 'Can you help me?', native: '¿Puede ayudarme?', transliteration: 'PWEH-deh ah-yoo-DAHR-meh?', responses: ['Sí, claro', 'Un momento', 'Lo siento, no puedo'] },
    { english: 'Do you speak English?', native: '¿Habla inglés?', transliteration: 'AH-blah een-GLEHS?', responses: ['Sí, un poco', 'No, lo siento', 'Un poquito'] },
    { english: 'I need a taxi', native: 'Necesito un taxi', transliteration: 'neh-seh-SEE-toh oon TAHK-see', responses: ['Espere aquí', 'Allí hay uno', 'Llame a este número'] },
    { english: 'Where is the train station?', native: '¿Dónde está la estación de tren?', transliteration: 'DOHN-deh eh-STAH lah eh-stah-see-OHN deh trehn?', responses: ['Siga recto', 'A dos cuadras', 'Está cerca'] },
    { english: 'What time is it?', native: '¿Qué hora es?', transliteration: 'keh OH-rah ehs?', responses: ['Son las tres', 'Mediodía', 'No sé'] },
    { english: 'I am lost', native: 'Estoy perdido', transliteration: 'eh-STOY pehr-DEE-doh', responses: ['¿Dónde quiere ir?', 'Le ayudo', 'Use este mapa'] },
    { english: 'Can I have the menu?', native: '¿Me da el menú?', transliteration: 'meh dah ehl meh-NOO?', responses: ['Aquí tiene', 'Un momento', 'Sí, claro'] },
    { english: 'Water please', native: 'Agua por favor', transliteration: 'AH-gwah por fah-VOR', responses: ['Ahora mismo', 'Con gas o sin gas?', 'Aquí tiene'] },
    { english: 'Where can I buy tickets?', native: '¿Dónde puedo comprar billetes?', transliteration: 'DOHN-deh PWEH-doh kohm-PRAHR bee-YEH-tehs?', responses: ['En la taquilla', 'En línea', 'Allí'] },
    { english: 'Is this seat taken?', native: '¿Está ocupado este asiento?', transliteration: 'eh-STAH oh-koo-PAH-doh EH-steh ah-see-EHN-toh?', responses: ['No, está libre', 'Sí, lo siento', 'Tome asiento'] },
    { english: 'I have an allergy', native: 'Tengo una alergia', transliteration: 'TEHN-goh OO-nah ah-LEHR-hee-ah', responses: ['¿A qué?', 'Lo anotamos', 'Sin problema'] },
    { english: 'Call the police', native: 'Llame a la policía', transliteration: 'YAH-meh ah lah poh-lee-SEE-ah', responses: ['Ahora mismo', 'Marque 112', '¿Qué pasó?'] },
    { english: 'Thank you very much', native: 'Muchas gracias', transliteration: 'MOO-chahs GRAH-see-ahs', responses: ['De nada', 'Un placer', 'No hay de qué'] },
    { english: 'Goodbye', native: 'Adiós', transliteration: 'ah-dee-OHS', responses: ['Adiós', 'Hasta luego', 'Que tenga buen día'] },
    { english: 'I do not understand', native: 'No entiendo', transliteration: 'noh ehn-tee-EHN-doh', responses: ['Más despacio', 'Le explico', 'En inglés?'] },
    { english: 'How do I get to...?', native: '¿Cómo llego a...?', transliteration: 'KOH-moh YEH-goh ah?', responses: ['Siga recto', 'Gire a la derecha', 'Tome el autobús'] },
    { english: 'Is it far?', native: '¿Está lejos?', transliteration: 'eh-STAH LEH-hohs?', responses: ['No, está cerca', 'Unos 10 minutos', 'Sí, bastante'] },
    { english: 'Good morning', native: 'Buenos días', transliteration: 'BWEH-nohs DEE-ahs', responses: ['Buenos días', 'Hola', 'Buen día'] }
  ],
  french: [
    { english: 'Where is the bathroom?', native: 'Où sont les toilettes?', transliteration: 'oo sohn lay twah-LET?', responses: ['À droite', 'À gauche', 'Au fond'] },
    { english: 'How much does this cost?', native: 'Combien ça coûte?', transliteration: 'kohm-bee-AN sah koot?', responses: ['Dix euros', 'Vingt euros', "C'est gratuit"] },
    { english: 'Can you help me?', native: 'Pouvez-vous m\'aider?', transliteration: 'poo-vay-VOO meh-DAY?', responses: ['Oui, bien sûr', 'Un instant', 'Désolé, je ne peux pas'] },
    { english: 'Do you speak English?', native: 'Parlez-vous anglais?', transliteration: 'par-lay-VOO ahn-GLEH?', responses: ['Oui, un peu', 'Non, désolé', 'Un petit peu'] },
    { english: 'I need a taxi', native: "J'ai besoin d'un taxi", transliteration: 'zhay beh-ZWAN dun tahk-SEE', responses: ['Attendez ici', 'Il y en a un là-bas', 'Appelez ce numéro'] }
  ],
  hindi: [
    { english: 'Where is the bathroom?', native: 'बाथरूम कहाँ है?', transliteration: 'bath-room ka-haan hai?', responses: ['दाहिने तरफ', 'बाएं तरफ', 'सीधे जाइए'] },
    { english: 'How much does this cost?', native: 'यह कितने का है?', transliteration: 'yeh kit-ne kaa hai?', responses: ['दस रुपये', 'सौ रुपये', 'यह मुफ्त है'] },
    { english: 'Can you help me?', native: 'क्या आप मेरी मदद कर सकते हैं?', transliteration: 'kyaa aap me-ree ma-dad kar sak-te hain?', responses: ['हाँ, ज़रूर', 'एक मिनट', 'माफ़ करें, नहीं कर सकते'] },
    { english: 'Do you speak English?', native: 'क्या आप अंग्रेज़ी बोलते हैं?', transliteration: 'kyaa aap an-gre-zee bol-te hain?', responses: ['हाँ, थोड़ी', 'नहीं, माफ़ करें', 'थोड़ी बहुत'] },
    { english: 'I need a taxi', native: 'मुझे टैक्सी चाहिए', transliteration: 'mu-jhe taik-see chaa-hi-ye', responses: ['यहाँ इंतज़ार करें', 'वहाँ एक है', 'इस नंबर पर फ़ोन करें'] }
  ]
};

export const mockUser = {
  id: '1',
  name: 'Travel Learner',
  email: 'learner@example.com',
  selectedLanguage: 'spanish',
  voiceGender: 'female',
  progress: {
    spanish: {
      nouns: 8,
      verbs: 12,
      questions: 15,
      totalSections: 35,
      completionPercentage: 60
    }
  },
  lastActive: new Date().toISOString(),
  streakDays: 5
};

export const mockAdminStats = {
  totalUsers: 2145,
  activeUsersDaily: 876,
  activeUsersMonthly: 1543,
  usersByCountry: [
    { country: 'United States', count: 543 },
    { country: 'India', count: 487 },
    { country: 'United Kingdom', count: 312 },
    { country: 'Canada', count: 289 },
    { country: 'Australia', count: 178 },
    { country: 'Germany', count: 156 },
    { country: 'France', count: 134 },
    { country: 'Spain', count: 46 }
  ],
  languagePopularity: [
    { language: 'Spanish', users: 789, percentage: 36.8 },
    { language: 'French', users: 534, percentage: 24.9 },
    { language: 'Hindi', users: 412, percentage: 19.2 },
    { language: 'German', users: 287, percentage: 13.4 },
    { language: 'Italian', users: 123, percentage: 5.7 }
  ],
  mostViewedLessons: [
    { title: 'Common Questions - Spanish', views: 4521 },
    { title: 'Common Nouns - French', views: 3876 },
    { title: 'Common Verbs - Hindi', views: 3245 },
    { title: 'Common Questions - German', views: 2987 },
    { title: 'Common Nouns - Spanish', views: 2654 }
  ]
};